import { FC, SVGProps } from 'react';

import { ReactComponent as GoogleIcon } from 'src/assets/svg/google.svg';
import { ReactComponent as StudentCrowdIcon } from 'src/assets/svg/student-crowd.svg';
import { ReactComponent as TrustpilotIcon } from 'src/assets/svg/trustpilot.svg';

export enum ReviewPlatform {
    Google = 'Google',
    StudentCrowd = 'StudentCrowd',
    Trustpilot = 'Trustpilot',
}

export const REVIEW_PLATFORM_ICON: Partial<Record<string, FC<SVGProps<SVGSVGElement>>>> = {
    [ReviewPlatform.Google]: GoogleIcon,
    [ReviewPlatform.StudentCrowd]: StudentCrowdIcon,
    [ReviewPlatform.Trustpilot]: TrustpilotIcon,
};

export const REVIEW_PLATFORM_CTA_TRANSLATION_KEY: Partial<Record<string, string>> = {
    [ReviewPlatform.Google]: 'feedback_page_confirmation_cta_google_rate',
    [ReviewPlatform.StudentCrowd]: 'feedback_page_confirmation_cta_student_crowd_rate',
    [ReviewPlatform.Trustpilot]: 'feedback_page_confirmation_cta_trustpilot_rate',
};

export const REVIEW_PLATFORM_CTA_FALLBACK_TRANSLATION_KEY = 'feedback_page_confirmation_cta_rate';
